export default value => {
  if (value) {
    return "Yes";
  } else {
    return "No";
  }
};
